<template>
  <div class="container mt-4">
    <h2 class="text-center mb-4">Gestión de Categorías de Tareas</h2>

    <!-- Agregar nueva categoría -->
    <div class="mb-4 p-3 border rounded bg-light">
      <h4>Nueva Categoría</h4>
      <div class="input-group">
        <input
          v-model="nuevaCategoria"
          type="text"
          class="form-control"
          placeholder="Nombre de la nueva categoría"
        />
        <button class="btn btn-primary input-group-text" @click="agregarCategoria">
          <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1" /> Agregar Categoría
        </button>
      </div>
    </div>

    <!-- Desplegable de categorías existentes -->
    <div class="mb-4">
      <label for="categoriaSelect" class="form-label">Seleccionar Categoría</label>
      <div class="input-group">
        <select v-model="categoriaSeleccionada" @change="categoriaChanged" class="form-select" id="categoriaSelect">
          <option v-for="categoria in categorias" :key="categoria.id" :value="categoria.id">{{ categoria.nombre }}</option>
        </select>
        <button class="btn btn-outline-danger input-group-text" @click="eliminarCategoriaSeleccionada" :disabled="!categoriaSeleccionada">
          <font-awesome-icon :icon="['fas', 'trash-alt']" class="me-1" /> Eliminar Categoría
        </button>
      </div>
    </div>

    <!-- Filtros de Estado de Atributos -->
    <div class="mb-4">
      <label for="estadoAtributo" class="form-label">Filtrar Atributos por Estado</label>
      <select v-model="filtroEstado" @change="filtrarAtributos" class="form-select" id="estadoAtributo">
        <option value="">Todos</option>
        <option value="true">Activos</option>
        <option value="false">Inactivos</option>
      </select>
    </div>

    <!-- Mostrar tareas y atributos de la categoría seleccionada -->
    <div v-if="categoriaSeleccionada && categoriaSeleccionadaData">
      <div>
        <h5>{{ categoriaSeleccionadaData.nombre }}</h5>

        <!-- Agregar nuevo nombre de tarea -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <button class="btn btn-success" @click="agregarNombreTarea(categoriaSeleccionada)" :disabled="totalNombreTareas >= clubActual.cantidad_maxima_variables_cultivo">
            <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1" /> Agregar Tarea
          </button>
          <span class="ms-3">{{ totalNombreTareas }} de {{ clubActual.cantidad_maxima_variables_cultivo }} tareas creadas</span>
        </div>

        <div v-if="totalNombreTareas >= clubActual.cantidad_maxima_variables_cultivo" class="alert alert-info text-center mb-4" role="alert">
          <strong>{{ totalNombreTareas }} de {{ clubActual.cantidad_maxima_variables_cultivo }} tareas creadas.</strong>
          <span v-if="totalNombreTareas >= clubActual.cantidad_maxima_variables_cultivo">
            Has alcanzado el límite máximo de tareas según tu plan actual.
          </span>
        </div>

        <div v-for="nombreTarea in categoriaSeleccionadaData.nombre_tareas" :key="nombreTarea.id" class="mb-3 p-3 border rounded bg-light">
          <div class="d-flex justify-content-between align-items-center">
            <h6>{{ nombreTarea.nombre }}</h6>
            <div>
              <button class="btn btn-outline-danger me-2" @click="eliminarNombreTarea(nombreTarea.id)">
                <font-awesome-icon :icon="['fas', 'trash-alt']" class="me-1" /> Eliminar Tarea
              </button>
              <button class="btn btn-outline-primary" @click="agregarAtributo(nombreTarea.id)">
                <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1" /> Agregar Atributo
              </button>
            </div>
          </div>

          <ul class="list-group mt-2">
            <li v-for="atributo in filtrarAtributosPorEstado(nombreTarea.atributos)" :key="atributo.id" class="list-group-item d-flex justify-content-between align-items-center">
              {{ atributo.nombre }} - {{ atributo.tipo_dato }} - [{{ atributo.atributo_activo ? 'Activo' : 'Inactivo' }}]
              <div>
                <button class="btn btn-sm btn-outline-secondary me-2" @click="toggleEstadoAtributo(atributo)">
                  <font-awesome-icon :icon="['fas', atributo.atributo_activo ? 'toggle-on' : 'toggle-off']" /> 
                </button>
                <button class="btn btn-sm btn-outline-danger" @click="eliminarAtributo(atributo.id)">
                  <font-awesome-icon :icon="['fas', 'trash-alt']" />
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Modal para agregar nuevos elementos -->
    <div v-if="mostrarModal" class="modal-overlay">
      <div class="modal-content">
        <h4>{{ modalTitulo }}</h4>
        <input
          v-model="nuevoElemento"
          type="text"
          class="form-control mb-3"
          :placeholder="modalPlaceholder"
        />
        <div v-if="elementoTipo === 'atributo'" class="mb-3">
          <label for="tipoDato" class="form-label">Tipo de Dato</label>
          <select v-model="tipoDatoSeleccionado" class="form-select" id="tipoDato">
            <option value="Integer">Integer</option>
            <option value="Decimal">Decimal</option>
            <option value="Text">Text</option>
            <option value="Date">Date</option>
          </select>
        </div>
        <button class="btn btn-success" @click="confirmarAgregarElemento">
          <font-awesome-icon :icon="['fas', 'check']" /> Confirmar
        </button>
        <button class="btn btn-danger" @click="cerrarModal">
          <font-awesome-icon :icon="['fas', 'times']" /> Cancelar
        </button>
      </div>
    </div>
  </div>
</template>
  




  <script>
  import axios from '@/axios';
  
  export default {
    data() {
      return {
        categorias: [],
        categoriaSeleccionada: null,
        categoriaSeleccionadaData: null,
        nuevaCategoria: '',
        mostrarModal: false,
        modalTitulo: '',
        modalPlaceholder: '',
        nuevoElemento: '',
        elementoTipo: null,
        elementoPadreId: null,
        tipoDatoSeleccionado: 'Text',
        tareasExpandidas: {},
        filtroEstado: '', // Variable para filtrar atributos por estado
        clubActual: null,

      };
    },
    computed: {
      totalNombreTareas() {
        return this.categorias.reduce((total, categoria) => total + categoria.nombre_tareas.length, 0);
      },
    },
    methods: {
        toggleExpandirTarea(nombreTareaId) {
          // Si el objeto tareasExpandidas no tiene la propiedad, la creamos y la establecemos como false
           // Verificar si la propiedad existe usando el operador 'in'
            if (!(nombreTareaId in this.tareasExpandidas)) {
                this.tareasExpandidas[nombreTareaId] = false;
            }
            // Alternar el estado de expandido/colapsado
            this.tareasExpandidas[nombreTareaId] = !this.tareasExpandidas[nombreTareaId];
        },
        async toggleEstadoAtributo(atributo) {
          try {
              const nuevoEstado = !atributo.atributo_activo;
              await axios.put(`/api/configuracion/atributos/${atributo.id}`, {
                atributo_activo: nuevoEstado,
              });
              atributo.atributo_activo = nuevoEstado; // Actualizar el estado localmente para reflejar el cambio
            } catch (error) {
              console.error('Error al cambiar el estado del atributo:', error);
              alert('No se pudo cambiar el estado del atributo. Inténtelo nuevamente.');
            }
          },
      filtrarAtributosPorEstado(atributos) {
        if (this.filtroEstado === '') return atributos; // Mostrar todos si no hay filtro seleccionado
        return atributos.filter((atributo) => atributo.atributo_activo.toString() === this.filtroEstado);
      },
      async cargarCategorias() {
        try {
          const response = await axios.get('/api/configuracion/categorias_tareas', { params: { club_id: this.clubActual.id } });
          this.categorias = response.data;
          if (this.categoriaSeleccionada) {
            this.categoriaSeleccionadaData = this.categorias.find(cat => cat.id === this.categoriaSeleccionada);
          }
        } catch (error) {
          console.error('Error al cargar las categorías:', error);
        }
      },
      async agregarCategoria() {
        if (!this.nuevaCategoria) return alert('El nombre de la categoría es obligatorio');
        try {
          const response = await axios.post('/api/configuracion/categorias_tareas', {form:{ nombre: this.nuevaCategoria }, club_id: this.clubActual.id });
          this.categorias.push(response.data);
          this.nuevaCategoria = '';
          //select the new category
        this.categoriaSeleccionada = response.data.id;
          await this.cargarCategorias(); // Actualizar categorías después de agregar una nueva
        } catch (error) {
          console.error('Error al agregar la categoría:', error);
        }
      },
      categoriaChanged() {
        this.categoriaSeleccionadaData = this.categorias.find(cat => cat.id === this.categoriaSeleccionada);
      },
      async eliminarCategoriaSeleccionada() {
        if (confirm('¿Estás seguro de que deseas eliminar esta categoría?')) {
          try {
            await axios.delete(`/api/configuracion/categorias_tareas/${this.categoriaSeleccionada}`, {data:{club_id: this.clubActual.id}});
            this.categorias = this.categorias.filter(cat => cat.id !== this.categoriaSeleccionada);
            this.categoriaSeleccionada = null;
            this.categoriaSeleccionadaData = null;
            this.cargarCategorias(); // Recargar categorías para reflejar la eliminación
          } catch (error) {
            console.error( error);
            //mostrar mensaje de error obtenido del servidor
            alert(error.response.data.error);
          }
        }
      },
      agregarNombreTarea(categoriaId) {
        this.mostrarModal = true;
        this.modalTitulo = 'Agregar Nueva Tarea';
        this.modalPlaceholder = 'Nombre de la tarea';
        this.elementoTipo = 'nombre_tarea';
        this.elementoPadreId = categoriaId;
      },
      agregarAtributo(nombreTareaId) {
        this.mostrarModal = true;
        this.modalTitulo = 'Agregar Nuevo Atributo';
        this.modalPlaceholder = 'Nombre del atributo';
        this.elementoTipo = 'atributo';
        this.elementoPadreId = nombreTareaId;
      },
      async confirmarAgregarElemento() {
        try {
          if (this.elementoTipo === 'nombre_tarea') {
            await axios.post('/api/configuracion/nombres_tareas', {
              nombre: this.nuevoElemento,
              categoria_id: this.elementoPadreId,
            });
            this.cargarCategorias(); // Actualizar las categorías y su data
          } else if (this.elementoTipo === 'atributo') {
            await axios.post('/api/configuracion/atributos', {
              nombre: this.nuevoElemento,
              nombre_tarea_id: this.elementoPadreId,
              tipo_dato: this.tipoDatoSeleccionado,
            });
            this.cargarCategorias(); // Actualizar categorías para reflejar el nuevo atributo
          }
          this.cerrarModal();
        } catch (error) {
          console.error('Error al agregar el elemento:', error);
          alert('Hubo un error al agregar el atributo. Por favor, intente nuevamente.');
        }
      },
      async eliminarNombreTarea(nombreTareaId) {
        if (confirm('¿Estás seguro de que deseas eliminar esta tarea?')) {
          try {
            await axios.delete(`/api/configuracion/nombres_tareas/${nombreTareaId}`);
            this.cargarCategorias(); // Recargar categorías para reflejar la eliminación
          } catch (error) {
            console.error(error);
            //mostrar mensaje de error obtenido del servidor
            alert(error.response.data.error);
          }
        }
      },
      async eliminarAtributo(atributoId) {
        if (confirm('¿Estás seguro de que deseas eliminar este atributo?')) {
          try {
            await axios.delete(`/api/configuracion/atributos/${atributoId}`);
            this.cargarCategorias(); // Recargar categorías para reflejar la eliminación del atributo
          } catch (error) {
            console.error('Error al eliminar el atributo:', error.response.data.error);
            //mostrar mensaje de error obtenido del servidor
            alert(error.response.data.error);
          }
        }
      },
      cerrarModal() {
        this.mostrarModal = false;
        this.nuevoElemento = '';
        this.tipoDatoSeleccionado = 'Text';
      },
    },
    mounted() {
      this.clubActual = this.$store.getters.getClubActual;
      

      this.cargarCategorias();
    },
  };
  </script>
  









  <style scoped lang="scss">
@import '@/scss/custom-bootstrap.scss';

.container {
  margin-top: 20px;
}

.card {
  margin-bottom: 20px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 1001;
  max-width: 500px; /* Definimos un ancho máximo para que el modal sea más pequeño */
  width: 90%; /* Ocupa el 90% del ancho de la pantalla pero no excede el max-width */
}

.list-group-item {
  background: #f8f9fa;
  border: none;
  margin-bottom: 5px;
}

.btn-outline-danger {
  margin-left: 10px;
}
.mb-3.p-3.border.rounded.bg-light {
  background-color: #f0f4f8 !important;
}

input-group-text {
  display: flex;
  align-items: center;
}

/* Aplicar colores de la paleta personalizada */
.btn-primary {
  background-color: $app-primary;
  border-color: $app-primary;
}

.btn-outline-primary {
  color: $app-accent;
  border-color: $app-accent;
}

.btn-outline-danger {
  color: $danger;
  border-color: $danger;
}

.btn-success {
  background-color: $success;
  border-color: $success;
}

.btn-danger {
  background-color: $danger;
  border-color: $danger;
}

h2, h4, h5, h6 {
  color: $dark;
}

.form-control, .form-select {
  border-radius: 4px;
  border-color: $light;
}

.modal-content {
  background-color: $light;
}

.alert {
  background-color: #e7f1ff;
  color: #0c5460;
  border: 1px solid #b8daff;
  border-radius: 4px;
}
</style>
